let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Nqdap")).then(() => parcelRequire('j0bRy'));